import { FormData as ProductFormData } from "../components/products-and-services/ProductForm";
import { axiosService } from "./axios.service";

const buildFormData = (form: ProductFormData) => {
  const formData = new FormData();
  Object.keys(form).forEach((key) => {
    formData.append(key, form[key]);
  });
  return formData;
};

enum ProductRequestBodyKey {
  CORRESPONDENCE = "correspondence",
  BLOCKCHAIN_ANALYSIS = "blockchainAnalysisProductRequest",
  TRACK_MASTER = "trackMasterProcess",
}

export class ProductService {
  static async sendProductRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean,
    bodyKey?: ProductRequestBodyKey
  ) {
    if (bodyKey) {
      return axiosService.post(`${href}`, {
        [bodyKey]: formData,
      });
    }
    if (hasFile) {
      const form = buildFormData(formData);
      return axiosService.post(`${href}`, form, true);
    }
    return axiosService.post(`${href}`, formData);
  }
}

export class CorrespondenceService {
  static async sendCorrespondenceRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(
      formData,
      href,
      hasFile,
      ProductRequestBodyKey.CORRESPONDENCE
    );
  }
}

export class BlockchainAnalysisService {
  static async sendBlockchainAnalysisRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(
      formData,
      href,
      hasFile,
      ProductRequestBodyKey.BLOCKCHAIN_ANALYSIS
    );
  }
}

export class TrackMasterService {
  static async sendTrackMasterRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(
      formData,
      href,
      hasFile,
      ProductRequestBodyKey.TRACK_MASTER
    );
  }
}

export class WebIntelligenceService {
  static async sendWebIntelligenceRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(formData, href, hasFile);
  }
}
export class BankDisputeService {
  static async sendBankDisputeRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(formData, href, hasFile);
  }
}
export class ExchangeDisputeService {
  static async sendExchangeDisputeRequest(
    formData: ProductFormData,
    href: string,
    hasFile: boolean
  ) {
    await ProductService.sendProductRequest(formData, href, hasFile);
  }
}
